import { INE_CALENDAR_SEARCH_START_LOADING, INE_CALENDAR_SEARCH_END_LOADING, INE_CALENDAR_SEARCH_LOADED, SET_INE_CALENDAR_FILTER } from "../constants/IneCalendarConstants";
import { getApiData, postApiJsonData, downloadFile } from "../utils/index";
import * as commonActions from "./CommonActions";

export function loadIneCalendarSearch(filters, navigate) {
    return async (dispatch) => {
        await dispatch({ type: INE_CALENDAR_SEARCH_START_LOADING });
        try {
            var data = await postApiJsonData("IneRequest/GetIneCalendarFBO", filters, null);
            if(data.success) {
                await dispatch({
                    type: INE_CALENDAR_SEARCH_LOADED,
                    payload: data.responseEntities[0]
                });
            } else {
                if(data.errorCode == "401") {
                    navigate('/not-authorized/');
                }
                dispatch(commonActions.setErrorMessage(data.errorDesc));
            }
            await dispatch({ type: INE_CALENDAR_SEARCH_END_LOADING });
        } catch (error) {
            dispatch(commonActions.setErrorMessage(error));
            await dispatch({ type: INE_CALENDAR_SEARCH_END_LOADING });
        }
    };
}

export function setIneCalendarFilter(filter) {
    return async (dispatch) => {
        await dispatch({
            type: SET_INE_CALENDAR_FILTER,
            payload: filter
        });
    };
}
